import React from "react"
import { bool, func } from "prop-types"
import styled, { css } from "styled-components"

import useWindowSize from "hooks/useWindowSize"
import { easeInQuint, easeOutQuint } from "styles/easings"

import { FormattedMessage } from "react-intl"
import * as spacings from "styles/spacing"
import { dark } from "styles/colors"
import Button from "components/Button"
import { Link } from "gatsby"
import Wave from "images/wave.png"

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: -${spacings.large};
  right: -${spacings.large};
  height: ${props => `${props.height}px`};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: all 0.4s ${easeInQuint};
  visibility: visible;
  opacity: 1;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);

  ${props =>
    !props.visible &&
    css`
      visibility: hidden;
      opacity: 0;
      transition: all 0.4s ${easeOutQuint};
    `}
`

const ContentInner = styled.div`
  position: absolute;
  max-width: 300px;
  height: 100%;
  top: 0;
  left: calc(50% - 150px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
`

const Inner = styled.div`
  position: relative;
  background-image: url("images/wave.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 190px ${spacings.large} 150px ${spacings.large}; */
  min-height: 400px;
`

const Title = styled.h2`
  font-size: 20px;
  color: ${dark};
  font-weight: 600;
  padding-bottom: ${spacings.medium};
`

const Content = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${dark};
  text-align: center;
  padding-bottom: ${spacings.large};
  font-weight: 500;
`

const Send = styled.span`
  padding: 0 ${spacings.large};
  font-size: 16px;
  font-weight: 600;
  color: white;
`

const Close = styled.div`
  height: 100%;
`

const Background = styled.img`
  /* position: absolute;
  left: 0;
  bottom: 0;
  right: 0; */
`

export const ModalMobile = ({ visible, setMobileModalVisible }) => {
  const { height } = useWindowSize()

  return (
    <div className="hide-small-down">
      <Container visible={visible} height={height}>
        <Close
          onClick={() => {
            setMobileModalVisible(false)
          }}
        />
        <Inner>
          <Background src={Wave} />
          <ContentInner>
            <Title>
              <FormattedMessage id="home.mobileModal.title" />
            </Title>
            <Content>
              <FormattedMessage id="home.mobileModal.content" />
            </Content>
            <Link
              style={{ zIndex: 100 }}
              href="https://testflight.apple.com/join/iqIfgITo"
            >
              <Button
                shadowed
                type="button"
                onClick={() => {
                  setMobileModalVisible(false)
                }}
              >
                <Send>
                  <FormattedMessage id="home.mobileModal.action" />
                </Send>
              </Button>
            </Link>
          </ContentInner>
        </Inner>
      </Container>
    </div>
  )
}

ModalMobile.propTypes = {
  visible: bool,
  setMobileModalVisible: func
}

export default ModalMobile
